import { useSearchDictionary } from 'components/helpers/AlgoliaSearch/util';
import { classnames } from 'tailwindcss-classnames';

interface ResetProps {
  onReset: () => void;
}

function Reset({ onReset }: ResetProps) {
  const dict = useSearchDictionary();

  return (
    <div>
      <button
        type="button"
        onClick={onReset}
        className={classnames(
          'bg-theme-btn-secondary-bg',
          'rounded-full',
          'font-semibold',
          'border',
          'border-2',
          'border-blue',
          'mt-4',
          'text-base',
          'text-blue',
          'px-6',
          'py-2',
          'w-full',
          'md:w-auto'
        )}
      >
        {dict.reset}
      </button>
    </div>
  );
}

export default Reset;
